import { render } from "./EditCar.vue?vue&type=template&id=6ee2f784&scoped=true"
import script from "./EditCar.vue?vue&type=script&lang=js"
export * from "./EditCar.vue?vue&type=script&lang=js"

import "./EditCar.vue?vue&type=style&index=0&id=6ee2f784&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\OneDrive\\Cookies BIS\\CookiesBIS\\core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ee2f784"]])

export default __exports__